import {
  ReturnCreationStatusSchema,
  ReturnReadyStatusSchema,
} from "@redotech/redo-model/returns/temporal-status";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getReturnCreationStatus = unaryStreamRpc({
  name: "getReturnCreationStatus",
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    workflowStartTime: z.date().nullish(),
    activityStatuses: z.array(
      z.union([ReturnCreationStatusSchema, ReturnReadyStatusSchema]),
    ),
    isWorkflowRunning: z.boolean().optional(),
  }),
});
